export default __webpack_public_path__ + "static/media/onboardingLogo.680d7a19.png";